<template>
  <div class="pagina-cuenta">
    <!-- CABECERA -->
    <div class="cabecera">
      <div class="avatar">{{ iniciales }}</div>
      <div class="identidad">
        <div class="nombre">{{ nombreCompleto || userInfo.user }}</div>
        <div class="usuario">@{{ userInfo.user }}</div>
        <div class="chips">
          <v-chip
            size="x-small"
            :color="esAdmin ? 'orange' : 'blue'"
            variant="flat"
          >
            {{ esAdmin ? 'Administrador' : 'Usuario' }}
          </v-chip>
        </div>
      </div>
    </div>

    <!-- DATOS -->
    <v-card class="tarjeta">
      <div class="grupo">Datos personales</div>

      <div class="grid-dos">
        <v-text-field
          v-model="userInfo.name"
          class="fg-blue"
          label="Nombre"
          variant="outlined"
          density="comfortable"
          :error-messages="errorNombre"
        />
        <v-text-field
          v-model="userInfo.surNames"
          class="fg-blue"
          label="Apellidos"
          variant="outlined"
          density="comfortable"
        />
      </div>

      <v-text-field
        v-model="userInfo.phoneNumber"
        class="fg-blue"
        label="Teléfono"
        type="tel"
        variant="outlined"
        density="comfortable"
      />

      <div class="grupo">Datos de acceso</div>

      <div class="grid-dos">
        <v-text-field
          v-model="userInfo.user"
          class="fg-blue"
          label="Usuario"
          variant="outlined"
          density="comfortable"
          readonly
          prepend-inner-icon="mdi-lock-outline"
        />
        <v-text-field
          v-model="userInfo.email"
          class="fg-blue"
          label="Correo"
          variant="outlined"
          density="comfortable"
          readonly
          prepend-inner-icon="mdi-lock-outline"
        />
      </div>

      <!-- El correo es la llave para entrar y para recuperar la cuenta, asi que
           cambiarlo exigiria verificar el nuevo con un codigo. Mientras eso no
           exista, se explica por que no se puede en vez de dejar el campo
           apagado sin motivo aparente. -->
      <p class="nota">
        El usuario y el correo no se pueden cambiar: son con lo que entras a tu
        cuenta. Si necesitas modificarlos, escríbenos.
      </p>

      <v-alert
        v-if="mensajeDatos"
        :type="tipoDatos"
        variant="tonal"
        density="compact"
        class="mb-3"
        closable
        @click:close="mensajeDatos = ''"
      >
        {{ mensajeDatos }}
      </v-alert>

      <v-btn
        color="primary"
        size="large"
        block
        :loading="guardando"
        @click="actualizar"
      >
        <v-icon start>mdi-content-save</v-icon>
        Guardar cambios
      </v-btn>
    </v-card>

    <!-- SEGURIDAD -->
    <v-card class="tarjeta">
      <div class="grupo">Seguridad</div>

      <div class="fila-seguridad">
        <div>
          <div class="titulo-fila">Contraseña</div>
          <div class="detalle-fila">Cámbiala si crees que alguien más la conoce</div>
        </div>
        <v-btn
          variant="tonal"
          @click="dialogContrasena = true"
        >
          <v-icon start>mdi-lock-reset</v-icon>
          Cambiar
        </v-btn>
      </div>
    </v-card>

    <!-- DIÁLOGO DE CONTRASEÑA -->
    <v-dialog
      v-model="dialogContrasena"
      max-width="440"
      @after-leave="limpiarDialogo"
    >
      <v-card class="pa-5">
        <div class="titulo-modal">
          <span>Cambiar contraseña</span>
          <v-btn
            icon
            variant="text"
            size="small"
            @click="dialogContrasena = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-text-field
          v-model="contrasenaActual"
          class="fg-blue"
          label="Contraseña actual"
          variant="outlined"
          density="comfortable"
          :type="verContrasenas ? 'text' : 'password'"
          :append-inner-icon="verContrasenas ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="verContrasenas = !verContrasenas"
        />
        <v-text-field
          v-model="nuevaContrasena"
          class="fg-blue"
          label="Nueva contraseña"
          variant="outlined"
          density="comfortable"
          :type="verContrasenas ? 'text' : 'password'"
          hint="Mínimo 5 caracteres, con al menos una letra y un número"
          persistent-hint
          :error-messages="errorNueva"
        />
        <v-text-field
          v-model="confirmarContrasena"
          class="fg-blue mt-3"
          label="Repetir la nueva"
          variant="outlined"
          density="comfortable"
          :type="verContrasenas ? 'text' : 'password'"
          :error-messages="errorConfirmacion"
        />

        <v-alert
          v-if="mensajeContrasena"
          :type="tipoContrasena"
          variant="tonal"
          density="compact"
          class="mb-3"
          closable
          @click:close="mensajeContrasena = ''"
        >
          {{ mensajeContrasena }}
        </v-alert>

        <v-btn
          color="primary"
          size="large"
          block
          :loading="cargandoContrasena"
          @click="cambiarContrasena"
        >
          Confirmar
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apisUsers from '@/apis/apisUsers';

// La misma regla que aplica el backend al cambiar la contrasena
const CLAVE = v => (String(v || '').length >= 5 && /[A-Za-z]/.test(v || '') && /\d/.test(v || ''))
  || 'Mínimo 5 caracteres, con al menos una letra y un número'

export default {
  name: 'AccountView',
  data() {
    return {
      userInfo: {
        idUser: null,
        user: "",
        password: "",
        name: "",
        surNames: "",
        email: "",
        age: null,
        role: "",
        phoneNumber: ""
      },
      intentoGuardar: false,
      guardando: false,
      mensajeDatos: "",
      tipoDatos: "success",

      dialogContrasena: false,
      contrasenaActual: "",
      nuevaContrasena: "",
      confirmarContrasena: "",
      verContrasenas: false,
      mensajeContrasena: "",
      tipoContrasena: "success",
      cargandoContrasena: false
    }
  },
  computed: {
    nombreCompleto() {
      return [this.userInfo.name, this.userInfo.surNames].filter(Boolean).join(' ').trim()
    },
    iniciales() {
      const base = this.nombreCompleto || this.userInfo.user || '?'
      return base.trim().split(/\s+/).slice(0, 2).map(p => p[0]).join('').toUpperCase()
    },
    esAdmin() {
      return (this.userInfo.role || '').toLowerCase() === 'administrador'
    },
    // El backend responde "El nombre es obligatorio"; se avisa antes de enviar
    errorNombre() {
      if (!this.intentoGuardar) return []
      return (this.userInfo.name || '').trim() === '' ? ['El nombre es obligatorio'] : []
    },
    errorNueva() {
      if (!this.nuevaContrasena) return []
      const r = CLAVE(this.nuevaContrasena)
      return r === true ? [] : [r]
    },
    errorConfirmacion() {
      if (this.confirmarContrasena && this.nuevaContrasena !== this.confirmarContrasena) {
        return ["Las contraseñas no coinciden"]
      }
      return []
    }
  },
  beforeCreate() {
    apisUsers.isValid()
      .then(isValid => {
        if (isValid) {
          apisUsers.GetMe().then(user => { this.userInfo = user })
        } else {
          this.$router.push('/')
        }
      })
  },
  methods: {
    actualizar() {
      this.intentoGuardar = true
      this.mensajeDatos = ""

      if (this.errorNombre.length > 0) {
        return
      }

      this.guardando = true

      apisUsers.updateUser(this.userInfo)
        .then(() => {
          this.mensajeDatos = "Datos actualizados correctamente"
          this.tipoDatos = "success"
        })
        .catch(err => {
          this.mensajeDatos = err.message || "Error al actualizar los datos"
          this.tipoDatos = "error"
        })
        .finally(() => {
          this.guardando = false
        })
    },
    cambiarContrasena() {
      this.mensajeContrasena = ""

      if (!this.contrasenaActual || !this.nuevaContrasena || !this.confirmarContrasena) {
        this.mensajeContrasena = "Completa todos los campos"
        this.tipoContrasena = "warning"
        return
      }
      if (CLAVE(this.nuevaContrasena) !== true) {
        this.mensajeContrasena = "La contraseña nueva no cumple el mínimo"
        this.tipoContrasena = "error"
        return
      }
      if (this.nuevaContrasena !== this.confirmarContrasena) {
        this.mensajeContrasena = "Las contraseñas nuevas no coinciden"
        this.tipoContrasena = "error"
        return
      }

      this.cargandoContrasena = true

      apisUsers.cambiarContrasena(this.contrasenaActual, this.nuevaContrasena)
        .then(() => {
          this.mensajeContrasena = "Contraseña actualizada correctamente"
          this.tipoContrasena = "success"
          this.contrasenaActual = ""
          this.nuevaContrasena = ""
          this.confirmarContrasena = ""
        })
        .catch(err => {
          this.mensajeContrasena = err.message || "Error al cambiar la contraseña"
          this.tipoContrasena = "error"
        })
        .finally(() => {
          this.cargandoContrasena = false
        })
    },
    limpiarDialogo() {
      this.contrasenaActual = ""
      this.nuevaContrasena = ""
      this.confirmarContrasena = ""
      this.mensajeContrasena = ""
      this.verContrasenas = false
    }
  }
}
</script>

<style scoped>
.pagina-cuenta {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px 12px 28px;
}

/* CABECERA */
.cabecera {
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #0d2f59 0%, #1976d2 100%);
  color: #fff;
  border-radius: 14px;
  padding: 18px 18px;
  margin-bottom: 14px;
}
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.identidad {
  min-width: 0;
}
.nombre {
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.usuario {
  font-size: 0.85rem;
  opacity: 0.85;
  margin-bottom: 6px;
}

/* TARJETAS */
.tarjeta {
  padding: 16px 16px 18px;
  margin-bottom: 14px;
  border-radius: 14px;
}

.grupo {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #1976d2;
  margin: 12px 0 12px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e3e8ef;
}
.grupo:first-child {
  margin-top: 0;
}

/* Una columna en celular: dos campos por fila aprietan */
.grid-dos {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0 10px;
}

.nota {
  font-size: 0.8rem;
  color: #777;
  line-height: 1.45;
  margin: 0 0 14px;
}

/* SEGURIDAD */
.fila-seguridad {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.titulo-fila {
  font-weight: 600;
  font-size: 0.95rem;
}
.detalle-fila {
  font-size: 0.8rem;
  color: #777;
}

.titulo-modal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 14px;
}

@media (min-width: 600px) {
  .pagina-cuenta {
    padding: 24px 16px 36px;
  }
  .cabecera {
    padding: 22px 24px;
  }
  .avatar {
    width: 66px;
    height: 66px;
    font-size: 1.4rem;
  }
  .nombre {
    font-size: 1.3rem;
  }
  .tarjeta {
    padding: 20px 24px 22px;
  }
  .grid-dos {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
